import placeholder from './homeSlide/placeholder';
import slides from './homeSlide/slides/index';

export default {
    placeholder,
    slides,
};
